module.exports = __webpack_public_path__ + "static/payments-accepted.1a71b084.png";